import { Case, Configuration } from "../../../shared/CaseModel";
import { getValueOfAssets } from "../../../shared/CaseModelUtility";
// the win chances the server varies, shared so the bargaining view cannot
// drift from what the calculation assumed
import { winChancesOfLeaves } from "../../../shared/winChance";
import { getCostSummary } from "../../CostSummaryValues.ts";

export function areEqual(c1: Configuration, c2: Configuration): boolean {
  // assets
  if (Object.keys(c1.assets).length !== Object.keys(c2.assets).length)
    return false;
  for (const defendantId in c1.assets) {
    if (c1.assets[defendantId] !== c2.assets[defendantId]) return false;
  }
  // costs
  if (Object.keys(c1.costs).length !== Object.keys(c2.costs).length)
    return false;
  for (const defendantId in c1.costs) {
    if (c1.costs[defendantId] !== c2.costs[defendantId]) return false;
  }

  if (Object.keys(c1.winChances).length !== Object.keys(c2.winChances).length)
    return false;
  for (const issueId in c1.winChances) {
    if (!areEqualWinChances(c1.winChances[issueId], c2.winChances[issueId]))
      return false;
  }

  return true;
}

export function areEqualWinChances(
  c1WinChance: {
    generic: boolean;
    genericWinChance: number;
    perDefendantWinChance: {
      [defendantId: string]: number;
    };
  },
  c2WinChance?: {
    generic: boolean;
    genericWinChance: number;
    perDefendantWinChance: {
      [defendantId: string]: number;
    };
  }
): boolean {
  if (c2WinChance === undefined) return false;
  if (c1WinChance.generic !== c2WinChance.generic) return false;
  if (c1WinChance.genericWinChance !== c2WinChance.genericWinChance)
    return false;
  for (const defendantId in c1WinChance.perDefendantWinChance) {
    if (
      c1WinChance.perDefendantWinChance[defendantId] !==
      c2WinChance.perDefendantWinChance[defendantId]
    )
      return false;
  }
  return true;
}

/**
 * The case's parameters as the bargaining variant varies them: costs and
 * assets per party, and the win chance of every issue (see
 * {@link winChancesOfLeaves}), as the server extracts its baseline.
 */
export function extract(c: Case): Configuration {
  const configuration: Configuration = {
    id: c.name,
    assets: {},
    costs: {},
    winChances: {},
    timestamp: Date.now(),
  };
  c.budgets?.forEach(
    (budget) =>
      (configuration.costs[budget.partyId] = getCostSummary(budget).totalCosts)
  );
  c.parties?.forEach((party) => {
    configuration.assets[party.id] = getValueOfAssets(party);
  });
  configuration.winChances = winChancesOfLeaves(c.claims);

  return configuration;
}
